import axios from 'axios'


// vue实例
let newVue = {
  obj: null,
  // baseURL: 'http://127.0.0.1:8080/xsalo'
  // baseURL: 'http://xsalo.cn/xsalo',
  baseURL: 'https://www.xsalo.cn/xsalo',
};

export {newVue};

export function requestMsg(config) {
  //创建axios实例
  const instance = axios.create({
    baseURL: newVue.baseURL,
    timeout: 50000,
    timeoutErrorMessage: "请求超时",
  });
  //axios的拦截器
  instance.interceptors.request.use(config => {
    if (newVue.obj!=null){config.headers.Authorization = newVue.obj.common.loginInfo.jwtToken;}
    return config;
  },err => {
    console.log(err);
  });

  instance.interceptors.response.use(res => {
    if (newVue.obj!=null){
      if (res.data.code==200){
        newVue.obj.$message({
          showClose: true,
          message: '操作成功',
          type: 'success'
        });
      }else if(res.data.code==401){
        sessionStorage["isLogin"] = false;
        sessionStorage.removeItem("jwtToken");
        sessionStorage.removeItem("adminId");
        newVue.obj.$router.push("/login");
      }else {
        newVue.obj.$message({
          showClose: true,
          message: res.data.message,
          type: 'error'
        })
      }
    }
    return res.data;
  },err =>  {
    if (err.data!=null){
      if(err.data.code==401){
        sessionStorage["isLogin"] = false;
        sessionStorage.removeItem("jwtToken");
        sessionStorage.removeItem("adminId");
        newVue.obj.$router.push("/login");
      }else {
        newVue.obj.$message({
          showClose: true,
          message: err.data.message,
          type: 'error'
        })
      }
    }else {
      newVue.obj.$message({
        showClose: true,
        message: err,
        type: 'error'
      })
    }
  });


  return instance(config)
}

export function request(config) {
  //创建axios实例
  const instance = axios.create({
    // baseURL: 'https://www.xsalo.cn/xsalo',
    // baseURL: 'http://127.0.0.1:8080/xsalo',
    baseURL: newVue.baseURL,
    timeout: 50000,
    timeoutErrorMessage: "请求超时",
  });

  //axios的拦截器
  instance.interceptors.request.use(config => {
    config.headers["Access-Control-Allow-Origin"] = "*";
    config.headers["Access-Control-Allow-Headers"] = "Origin, X-Requested-With, Content-Type, Accept";
    config.headers.Authorization = newVue.obj.common.loginInfo.jwtToken;
    return config;
  },err => {
    console.log(err);
  });

  instance.interceptors.response.use(res => {
    if (newVue.obj!=null){
      if (res.data.code==200){

      }else if(res.data.code==401){
        sessionStorage["isLogin"] = false;
        sessionStorage.removeItem("jwtToken");
        sessionStorage.removeItem("adminId");
        newVue.obj.$router.push("/login")
      }else{
        newVue.obj.$message({
          showClose: true,
          message: res.data.message,
          type: 'error'
        })
      }
    }
    return res.data;
  },err =>  {
    if (err.data!=null){
      if(err.data.code==401){
        sessionStorage["isLogin"] = false;
        sessionStorage.removeItem("jwtToken");
        sessionStorage.removeItem("adminId");
        newVue.obj.$router.push("/login")
      }else {
        newVue.obj.$message({
          showClose: true,
          message: err.data.message,
          type: 'error'
        })
      }
    }else {
      newVue.obj.$message({
        showClose: true,
        message: err,
        type: 'error'
      })
    }
  })


  return instance(config)
}
